"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stockpileConfigTypes = exports.stockpileConfigReducer = exports.stockpileAction = void 0;
const stockpile_component_1 = __importDefault(require("./sub-components/stockpile.component"));
const stockpile_action_1 = __importDefault(require("./stockpile.action"));
exports.stockpileAction = stockpile_action_1.default;
const stockpile_reducer_1 = __importDefault(require("./stockpile.reducer"));
exports.stockpileConfigReducer = stockpile_reducer_1.default;
const stockpile_types_1 = require("./stockpile.types");
Object.defineProperty(exports, "stockpileConfigTypes", { enumerable: true, get: function () { return stockpile_types_1.stockpileConfigTypes; } });
exports.default = stockpile_component_1.default;
